import React, { useContext } from 'react'
import { SpinnerContext } from '../../../context/spinnerContext'
import { useDispatch } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { creditCardSchema } from '../../../util/validationSchema'
import cardValidator from 'card-validator'
import InputMask from 'react-input-mask'
import { addNewCard } from '../../../redux/slices/paymentSlice'
import { usePaymentInputs } from 'react-payment-inputs'
import { PaymentIcon } from 'react-svg-credit-card-payment-icons'
import CreditCard from './creditCard'
const AddEditCreditCard = ({ toggle, setIsRefresh }) => {
  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()
  const { getCardNumberProps } = usePaymentInputs()
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    trigger,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(creditCardSchema),
    defaultValues: {
      card_size: 3
    }
  })
  const fieldData = watch()
  const onSubmit = async (data) => {
    if (!data) return
    setIsRefresh(false)
    let argument = {
      card_holder: data?.card_holder,
      card_number: data?.card_number,
      card_type: data?.card_type?.niceType,
      cvc: data?.cvc,
      expired_at: data?.expired_at
    }
    try {
      changeLoader(true)
      const { payload } = await dispatch(addNewCard(argument))
      // Handle successful response
      if (payload?.status === 200) {
        successToast(payload?.data?.status_message || 'Success!')
        toggle()
        reset()
        setIsRefresh(true)
      } else {
        // Handle error response
        errorToast(payload?.data?.status_message || 'Something went wrong')
      }
    } catch (error) {
      // Handle unexpected errors
      errorToast('An unexpected error occurred')
    } finally {
      changeLoader(false) // Ensure loader is stopped regardless of success or failure
    }
  }

  const handleCardNumberChange = (event) => {
    const cardNumber = event.target.value.replace(/\s/g, '')
    const detectedCard = cardValidator.number(cardNumber)
    setValue('card_size', detectedCard?.card?.code?.size)
    setValue('card_type', detectedCard.card ? detectedCard.card : null)
  }

  return (
    <>
      <div className="mb-4">
        <CreditCard fieldData={fieldData} />
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-md-12 col-12">
          <div className="form-group input_text">
            <label className="form-control-label">Cardholder Name</label> <span className="text-danger">*</span>
            <Controller
              name="card_holder"
              control={control}
              render={({ field: { value, onChange } }) => (
                <input
                  className={`form-control ${errors?.card_holder ? 'error-input' : ''}`}
                  type="text"
                  value={value || ''}
                  onChange={onChange}
                  autoComplete="false"
                  placeholder="Cardholder Name"
                />
              )}
            />
            <small>{errors?.card_holder?.message}</small>
          </div>
        </div>
        <div className="col-md-12 col-12">
          <div className="form-group input_text">
            <label className="form-control-label">Card Number</label> <span className="text-danger">*</span>
            <div className="position-relative">
              <Controller
                name="card_number"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    {...getCardNumberProps({
                      onChange: (val) => {
                        onChange(val)
                        if (!val.target.value) {
                          setValue('cvc', '')
                        }
                        handleCardNumberChange(val)
                        if (Object.keys(errors)?.length > 0) {
                          trigger('cvc')
                        }
                      }
                    })}
                    value={value}
                    autoComplete="false"
                    className={`form-control pe-5 ${errors?.card_number ? 'error-input' : ''}`}
                    placeholder="Card Number"
                    maxLength={19}
                  />
                )}
              />
              {watch('card_type') && <PaymentIcon type={watch('card_type')?.type} width={50} className="img-fluid payment_icon_div" />}
            </div>
            <small>{errors?.card_number?.message}</small>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 col-12">
            <div className="form-group input_text">
              <label className="form-control-label">Expiry Date</label> <span className="text-danger">*</span>
              <Controller
                name="expired_at"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <InputMask
                    mask="9999-99"
                    value={value}
                    onChange={onChange}
                    className={`form-control ${errors?.expired_at ? 'error-input' : ''}`}
                    placeholder="YYYY-MM"
                    autoComplete="off"
                  >
                    {(inputProps) => <input {...inputProps} />}
                  </InputMask>
                )}
                defaultValue=""
              />
              <small>{errors?.expired_at?.message}</small>
            </div>
          </div>

          <div className="col-md-6 col-12">
            <div className="form-group input_text">
              <label className="form-control-label">
                CVC <span className="text-danger">*</span>
              </label>
              <Controller
                name="cvc"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    className={`form-control ${errors?.cvc ? 'error-input' : ''}`}
                    type="password"
                    maxLength={fieldData?.card_size}
                    value={value}
                    onChange={(val) => {
                      onChange(val)
                      if (Object.keys(errors)?.length > 0) {
                        trigger('cvc')
                      }
                    }}
                    placeholder="CVC"
                    autoComplete="false"
                    disabled={!fieldData?.card_number}
                  />
                )}
              />
              <small>{errors?.cvc?.message}</small>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <button className="btn btn-lg btn-block btn-primary w-100" type="submit">
          Save
        </button>
      </form>
    </>
  )
}

export default AddEditCreditCard
